export default __webpack_public_path__ + "static/media/icon3.15f74e29.svg";